import imgCardResult1 from "../../assets/images/card-result1.png";
import imgCardResult2 from "../../assets/images/card-result2.png";
import imgCardResult3 from "../../assets/images/card-result3.png";
import ApiPlannings from "../../services/planning";
import "./index.scss";
import {eventTag} from "../../services/utils";

const CardResult = ({ selected, list, callback, eventRecommendations}) => {
  const api = ApiPlannings();
  const handleIsViwer = async (link, id, title) => {
    try{
      const {data} = await api.updateRecommendations(id, list)
      eventTag(eventRecommendations?.name, eventRecommendations?.category, eventRecommendations?.action, `Recomendação lida: ${title}`)

      window.open(link, '_blank')
      callback()
    } catch(error){
      console.warn(error)
    }
  }

  const categoryTranslate = {
    strategic: "estratégico",
    operational: "operacional",
    financial: "financeiro",
  }

  return (
    <>
      {list.map((item, index) => (
        <div key={item.id} className={`wrapper-card-result ${selected}`}>
          <figure>
            <img
              src={
                item.base_info.category === "Cartilha"
                  ? imgCardResult2
                  : item.base_info.category === "eBook"
                    ? imgCardResult3
                    : imgCardResult1
              }
              alt="imagem do card de prioridades"
            />
          </figure>
          <div className="wrapper-card__text">
            <p className={`type ${item.base_info.category}`}>
              { categoryTranslate[item.base_info.category] || item.base_info.category}
            </p>
            <p className={`title-card ${item.base_info.rec_type}`}>
              {item.base_info.title}
            </p>
            <button className="btn-document-results" onClick={() => handleIsViwer(item.base_info.link, item.id, item.base_info?.title)} data-link={`${item.base_info.link}`}>
              Saiba Mais
            </button>
          </div>
        </div>
      ))}
    </>
  );
};

export default CardResult;
